<script setup lang="ts">
import type { UserAvatarEntity, UserAvatarInitialsUi } from '#layers/access/types/user-avatar';
import type { GlobalFileId } from '#layers/data-model';
import { computed, ref, watch } from 'vue';
import UserAvatarInitials from './UserAvatarInitials.vue';

const props = defineProps<{
	user: UserAvatarEntity;
	ui?: UserAvatarInitialsUi;
}>();

const avatarId = computed<GlobalFileId | null>(() => 'avatarId' in props.user ? props.user.avatarId ?? null : null);
const imageAlt = computed(() => props.user.fullName ?? ('email' in props.user ? props.user.email : '') ?? '');
const hasError = ref(false);

watch(avatarId, () => {
	hasError.value = false;
});
</script>

<template>
	<span class="relative inline-block overflow-hidden rounded-full">
		<NuxtImg
			v-if="avatarId && !hasError"
			:src="avatarId"
			:alt="imageAlt"
			:modifiers="{ project: undefined }"
			class="size-full object-cover"
			@load="hasError = false"
			@error="hasError = true"
		/>
		<UserAvatarInitials v-else :user :ui />
	</span>
</template>
